export const OPEN_DATA_SECURITY_TRANSACTION = 'DATA_SECURITY.OPEN_DATA_SECURITY_TRANSACTION';
export const SET_ACTIVE_PANEL_GUID = 'DATA_SECURITY.SET_ACTIVE_PANEL_GUID';

export const ON_ITEM_CLICKED = 'DATA_SECURITY.ON_ITEM_CLICKED';
export const SET_ACTIVE_NODE_ID = 'DATA_SECURITY.SET_ACTIVE_NODE_ID';

export const SET_DATA_SECURITY_LOADING = 'DATA_SECURITY.SET_DATA_SECURITY_LOADING';
